import {EmptyState, Text} from '@shopify/polaris';
import {useStatus} from '@shopify/react-network';
import {useI18n} from '@shopify/react-i18n';
import {ErrorResponse, useRouteError} from 'react-router-dom';
import {notFoundIllustration} from 'illustrations';

export function ErrorFallback() {
  const [i18n] = useI18n();
  const error = useRouteError() as ErrorResponse;
  useStatus(error.status);

  return (
    <EmptyState
      heading={i18n.translate('Common.serverError')}
      image={notFoundIllustration}
    >
      <Text as="p">
        {error.statusText
          ? error.statusText
          : i18n.translate('Common.errorDescription')}
      </Text>
    </EmptyState>
  );
}
